import { emailsBan } from './emails-ban';
function ctInputs() {
  function init() {
    jQuery('input[type=tel]').on('keydown', keydownInput);
    jQuery('input[type=email]').on('keyup', validateEmail);
  }
  function validateEmail(e) {
    const email = this.value;
    const isBan = emailsBan.some(ban => {
      const txt = "@" + ban;
      const indexEmail = email.indexOf(txt);
      return (indexEmail > 0);
    });
    if (isBan) {
      setTimeout(() => {
        const parent = $(this).parent();
        const span = parent.find('.wpcf7-not-valid-tip');
        if (span.length == 0) {
          const span = $("<span class='wpcf7-not-valid-tip'>");
          span.html("Introduzca la dirección de correo electrónico de tu empresa.");
          parent.append(span);
        }
      }, 10);
    }

  }
  function keydownInput(e) {
    if (
      [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105) &&
      e.keyCode != 189
    ) {
      e.preventDefault();
    }
  }
  init();
}
ctInputs();